<div class="d-flex row align-items-center" (click)="addItemClicked?.emit(true)">
  <div class="p2 ml-3 mt-3 mb-3">{{ info }}</div>
  <div class="p2 ml-auto mt-3 mb-3 mr-3 rr-plus"></div>
</div>
